import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
  return (
    <div className="min-h-screen bg-hero-gradient">
      <Header />
      <main className="mx-auto flex w-full max-w-6xl flex-1 flex-col px-4 pb-16 pt-6 sm:px-6 lg:px-8 lg:pt-8">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
